import React from 'react';

import InputError from './InputError';

const SingleInput = (props) => (
	<div className="form-group">
		<span className="input input--madoka">
			<input 
				className="input__field input__field--madoka" 
				type={props.inputType}
				id={props.name}
				value={props.content}
				onChange={props.controlFunc}
			/>
			<label className="input__label input__label--madoka" htmlFor={props.name}>
				<svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
					<path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
				</svg>
				<span className="input__label-content input__label-content--madoka">{props.title}</span>
			</label>
		</span>
		<InputError errorClass={props.validate} errorMessage={props.errorMessage}/>
	</div>
);

SingleInput.propTypes = {  
  inputType: React.PropTypes.oneOf(['text', 'tel', 'email']).isRequired,
  title: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  controlFunc: React.PropTypes.func.isRequired,
  content: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.number,
  ]).isRequired,
  placeholder: React.PropTypes.string,
};

export default SingleInput;


// WEBPACK FOOTER //
// ./src/components/formComponents/SingleInput.js